import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import React, { ReactNode } from "react";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        gap: "24px",
        padding: "8px 0px",
        minHeight: "32px",
        "@media (max-width: 600px)": {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "4px",
        },
    },
    label: {
        width: (props: { labelWidth: string }) => props.labelWidth,
        flexShrink: 0,
        "@media (max-width: 600px)": {
            width: "100%",
            fontWeight: 600,
            fontSize: "12px",
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: theme.palette.text.disabled,
        },
    },
    value: {
        flexGrow: 1,
        "@media (max-width: 600px)": {
            width: "100%",
        },
    },
}));

interface LabeledValueProps {
    label: ReactNode;
    value: ReactNode;
    labelWidth?: string;
};

export const LabeledValue: React.FC<LabeledValueProps> = ({
    label,
    value,
    labelWidth = "150px",
}) => {
    const classes = useStyles({ labelWidth });

    return (
        <div className={classes.container}>
            <label className={classes.label}>{label}</label>
            <div className={classes.value}>{value}</div>
        </div>
    );
};
